import { KommmissionierungStrategy } from './kommmissionierung.strategy';
import { ArtikelMenge, Charge, LagerplatzInhalt } from '@softapps/lager/core';
import { KommissionsauftragKopf } from '../types/kommissionsauftrag';
import { selectStockRow } from '../functions/select-stock-row.function';

export class KommscheinStrategy implements KommmissionierungStrategy {
  loadLagerplatzVorschlag = true;
  begleitscheindruck = true;

  constructor(public lagerplatzAuswahl: boolean) {}

  getMaxMenge(
    lagerplatz: LagerplatzInhalt | undefined,
    artikelMenge: ArtikelMenge | undefined,
    charge?: Charge | null
  ): number {
    if (!lagerplatz || !artikelMenge) return 0;
    const lagerplatzMenge = selectStockRow(lagerplatz, artikelMenge, charge)?.menge ?? 0;
    const beweMenge = artikelMenge.menge ?? 0;
    return beweMenge < lagerplatzMenge ? beweMenge : lagerplatzMenge;
  }

  getPalettenBegleitscheinMenge(auftrag: KommissionsauftragKopf): number {
    switch (auftrag?.lieferart) {
      case 'A':
        return 0;
      default:
        return 1;
    }
  }
}
